<section class="card mb-3 my-task" order-id="card-3">
    <div class="card-header">
        <div class="header-title-section">
            <h5 class="mb-0 d-inline-block">
                My Task
            </h5>
            <div class="header-icons-group">
                <div class="company-toggle-switch">
                    <span class="toggle-label" [class.active]="!loadAllCompanies" (click)="setLoadAllCompanies(false)">Current Company</span>
                    <label class="toggle-switch">
                        <input type="checkbox" [checked]="loadAllCompanies" (change)="toggleLoadAllCompanies()">
                        <span class="toggle-slider"></span>
                    </label>
                    <span class="toggle-label" [class.active]="loadAllCompanies" (click)="setLoadAllCompanies(true)">All Companies</span>
                </div>
                <i class="fa fa-table header-icon-btn" style="cursor: pointer;" data-original-title="Show Table" 
                    data-placement="left" data-toggle="tooltip" title="Bulk Update" (click)="bulkUpdateModal($event)"></i>
            </div>
        </div>
    </div>
    
    <!-- Kanban Board -->
    <div class="kanban-board">
        <!-- Pending Column -->
        <div class="kanban-column kanban-pending">
            <div class="kanban-column-header">
                <span class="kanban-column-title">Pending</span>
                <span class="kanban-column-count">{{ pendingTasks.length }}</span>
            </div>
            <div class="kanban-column-body">
                <div class="kanban-card" *ngFor="let task of pendingTasks" (click)="taskDetails(task)">
                    <div class="kanban-card-title">{{ task.TaskName }}</div>
                    <div class="kanban-card-company">{{ task.CompanyName }}</div>
                    <div class="kanban-card-dates">
                        <span class="kanban-date"><i class="fa fa-calendar-o"></i> {{ task.EndDate | date : "dd MMM" }}</span>
                    </div>
                </div>
                <div class="kanban-empty" *ngIf="pendingTasks.length === 0">
                    <span>No pending tasks</span>
                </div>
            </div>
        </div>

        <!-- In Progress Column -->
        <div class="kanban-column kanban-inprogress">
            <div class="kanban-column-header">
                <span class="kanban-column-title">In Progress</span>
                <span class="kanban-column-count">{{ inProgressTasks.length }}</span>
            </div>
            <div class="kanban-column-body">
                <div class="kanban-card" *ngFor="let task of inProgressTasks" (click)="taskDetails(task)">
                    <div class="kanban-card-title">{{ task.TaskName }}</div>
                    <div class="kanban-card-company">{{ task.CompanyName }}</div>
                    <div class="kanban-card-dates">
                        <span class="kanban-date"><i class="fa fa-calendar-o"></i> {{ task.EndDate | date : "dd MMM" }}</span>
                    </div>
                </div>
                <div class="kanban-empty" *ngIf="inProgressTasks.length === 0">
                    <span>No tasks in progress</span>
                </div>
            </div>
        </div>

        <!-- Completed Column -->
        <div class="kanban-column kanban-completed">
            <div class="kanban-column-header">
                <span class="kanban-column-title">Completed</span>
                <span class="kanban-column-count">{{ completedTasks.length }}</span>
            </div>
            <div class="kanban-column-body">
                <div class="kanban-card" *ngFor="let task of completedTasks" (click)="taskDetails(task)">
                    <div class="kanban-card-title">{{ task.TaskName }}</div>
                    <div class="kanban-card-company">{{ task.CompanyName }}</div>
                    <div class="kanban-card-dates">
                        <span class="kanban-date"><i class="fa fa-check-circle"></i> {{ task.EndDate | date : "dd MMM" }}</span>
                    </div>
                </div>
                <div class="kanban-empty" *ngIf="completedTasks.length === 0">
                    <span>No completed tasks</span>
                </div>
            </div>
        </div>

        <!-- Closed Column (Cancelled/NA) -->
        <div class="kanban-column kanban-closed">
            <div class="kanban-column-header">
                <span class="kanban-column-title">Closed</span>
                <span class="kanban-column-count">{{ closedTasks.length }}</span>
            </div>
            <div class="kanban-column-body">
                <div class="kanban-card" *ngFor="let task of closedTasks" (click)="taskDetails(task)">
                    <div class="kanban-card-title">{{ task.TaskName }}</div>
                    <div class="kanban-card-company">{{ task.CompanyName }}</div>
                    <div class="kanban-card-dates">
                        <span class="kanban-date"><i class="fa fa-times-circle"></i> {{ task.EndDate | date : "dd MMM" }}</span>
                    </div>
                </div>
                <div class="kanban-empty" *ngIf="closedTasks.length === 0">
                    <span>No closed tasks</span>
                </div>
            </div>
        </div>
    </div>
</section>